import { render, staticRenderFns } from "./AuthModule.vue?vue&type=template&id=45c7965a&"
import script from "./AuthModule.vue?vue&type=script&lang=js&"
export * from "./AuthModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports